import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { isThemableToken } from '../../util/mappers.util.js';
import { getSpacing } from '../../util/spacing.js';
import { selectIntentColorToken, selectToken } from '../../util/tokenSelector.js';
import '../Loader/Skeleton/index.js';
import { useIntentContext } from '../../contexts/Intent/hooks/useIntentContext.js';
import { useExperimentContext } from '../../contexts/session/Experiment.js';
import { useLocaleContext, Direction } from '../../contexts/session/Locale.js';
import { usePlatformContext } from '../../contexts/session/Platform.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { useIconInitializer } from './hooks/useIconInitializer.js';
import { IconStyled } from './Icon.styled.js';
import { getHash } from './utility/Icon.helper.js';
import { SkeletonLoader as SkeletonLoaderMemoized } from '../Loader/Skeleton/Skeleton.js';

var _excluded = ["id", "size", "direction", "skeleton", "shape", "label", "color"];
var Icon = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
    sizeProp = props.size,
    directionProp = props.direction,
    skeleton = props.skeleton,
    shape = props.shape,
    label = props.label,
    color = props.color,
    rest = _objectWithoutProperties(props, _excluded);
  var _useLocaleContext = useLocaleContext(),
    direction = _useLocaleContext.direction,
    locale = _useLocaleContext.locale;
  var _usePlatformContext = usePlatformContext(),
    platform = _usePlatformContext.platform;
  var theme = useThemeContext();
  var _useIntentContext = useIntentContext(),
    intent = _useIntentContext.intent;
  var experiments = useExperimentContext();
  var size = theme.icons[sizeProp];
  var _getHash = getHash(id, {
      theme: theme.name,
      experiments: experiments,
      direction: direction,
      locale: locale,
      platform: platform
    }),
    hash = _getHash.hash,
    flip = _getHash.flip;
  var _useIconInitializer = useIconInitializer(hash),
    isLoaded = _useIconInitializer.isLoaded;
  if (!isLoaded && skeleton) {
    return /*#__PURE__*/React.createElement(SkeletonLoaderMemoized, _extends({
      shape: shape,
      display: "inline-block",
      width: size,
      height: size,
      label: label
    }, props));
  }
  var fill = isThemableToken(color || '') ? selectIntentColorToken(theme.intent, 'text', color, intent) : selectToken(theme.text, color);
  var spacing = getSpacing(props, direction, theme.spacing);

  // TODO: ADSWEB-333 Icon accessibility with <title> element
  return /*#__PURE__*/React.createElement(IconStyled, _extends({
    role: "img",
    "aria-hidden": !label ? true : undefined,
    "aria-label": label,
    $direction: flip ? Direction.RTL : directionProp,
    $size: size,
    $fill: fill,
    opacity: props.opacity
  }, spacing, rest), /*#__PURE__*/React.createElement("use", {
    href: "#".concat(hash)
  }));
});
Icon.displayName = 'IconDeprecated';
Icon.defaultProps = {
  direction: Direction.LTR,
  skeleton: false,
  shape: 'rectangle',
  opacity: 1
};

export { Icon as IconDeprecated };
//# sourceMappingURL=IconDeprecated.js.map
